<template>
  <div>
    <div v-for="a in alerts" :key="a.id" class="alert-item">
      <ATagToRoute>
        <div v-html="a.message"></div>
      </ATagToRoute>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.alert-item {
  @apply tw-bg-danger tw-rounded-[0.8rem] tw-w-full tw-mb-4 tw-p-4 tw-text-mainbg1;
}

.alert-item :deep(a) {
  @apply tw-text-mainbg1;
}
</style>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import { SfUserAlertMessage } from "@/types/generalTypes";
import { defineComponent } from "vue";
import ATagToRoute from "./shared/ATagToRoute.vue";

export default defineComponent({
  components: { ATagToRoute },
  data() {
    return {
      alerts: [] as SfUserAlertMessage[],
    };
  },
  mounted() {
    this.refreshAlerts();
  },
  methods: {
    async refreshAlerts() {
      const data = await apiCall("user-alert-message", { tgt: "top" });
      if (data.success) {
        this.alerts = data.data.items;
      }
    },
  },
});
</script>
